import * as fromDiscounts from './discounts.actions';
import { createReducer } from '@reduxjs/toolkit';
import { IDiscountProgrammInfo, IDiscountWarning, IProductDiscountInfo } from '../models/order-discount-info.model';


export interface DiscountsState {
  productDiscounts: IProductDiscountInfo[];
  programs: IDiscountProgrammInfo[];
  totalDiscount: number;
  freeProductExternalIds: string[];
  warnings: IDiscountWarning[];
  isLoading: boolean
}

export const initialState: DiscountsState = {
  programs: [],
  productDiscounts: [],
  freeProductExternalIds: [],
  totalDiscount: 0,
  warnings: [],
  isLoading: false
};


export const discountsReducer = createReducer(initialState, (builder) => {
  builder.addCase(fromDiscounts.discountsUpdateAction, (state, action) => {
    return {
      ...state,
      isLoading: false,
      warnings: [...action.payload.warnings],
      totalDiscount: action.payload.totalDiscount,
      freeProductExternalIds: [...action.payload.freeProductExternalIds],
      productDiscounts: [...action.payload.productDiscounts],
      programs: [...action.payload.programs]
    };
  });
  builder.addCase(fromDiscounts.discountsClearAction, (state) => {
    return {
      ...state,
      isLoading: false,
      warnings: [],
      totalDiscount: 0,
      freeProductExternalIds: [],
      productDiscounts: [],
      programs: []
    };
  });
  builder.addCase(fromDiscounts.discountsShouldBeUpdatedAction, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  });
});
